"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALGOLIA_SESSION_CURATED_LIST_LIMIT = exports.SWISH_URL = exports.SWISH_MERCHANT_NUMBER = exports.BASE_URL = exports.ReplayFilename = exports.OfferCoupons = exports.KvixConstants = void 0;
const hostname_1 = require("./hostname");
exports.KvixConstants = {
    CONTACT_EMAIL: "support@kvix.tv",
    SENDER_EMAIL: "team@kvix.tv",
    CHAT_MAX_VISIBLE_REACTIONS: 20,
    CARD_MAX_HIGHLIGHTED_USERS: 10,
};
exports.OfferCoupons = {
    SCHIBSTED: "585366",
};
exports.ReplayFilename = {
    mp4: "replay.mp4",
    hls: "replay.m3u8",
};
exports.BASE_URL = hostname_1.Hostname.client.default();
exports.SWISH_MERCHANT_NUMBER = process.env.SWISH_MERCHANT_NUMBER;
exports.SWISH_URL = process.env.SWISH_URL;
exports.ALGOLIA_SESSION_CURATED_LIST_LIMIT = 50;
//# sourceMappingURL=constants.js.map